// import _BaseAPIService from "../_BaseAPIService";

// const apiService = _BaseAPIService.instance;

// const ComplimentryService = {
//   getAll: async () => {
//     const response = await apiService.get(`/complimentrylogs/filter`);
//     return response.data;
//   },
//    getGrpItem: async () => {
//     const response = await apiService.get(`/complimentrylogs/grouped`);
//     return response.data;
//   },
//   detail: async (orderId) => {
//     const response = await apiService.get(
//       `/complimentrylogs/by-order/${orderId}`
//     );
//     return response.data;
//   },
// };

// export default ComplimentryService;

import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const ComplimentryService = {
  getAll: async ({
    page = 1,
    pageSize = 10,
    itemName = "",
    itemId = null,
    startDate = null,
    endDate = null,
  }) => {
    const response = await apiService.get("/complimentrylogs/filter", {
      params: {
        page,
        pageSize,
        itemName,
        itemId,
        startDate,
        endDate,
      },
      headers: {
        authorization: "Bearer " + _BaseAPIService.retrieveToken(),
      },
    });

    return response.data;
  },

  getByOrder: async (orderId) => {
    const response = await apiService.get(
      `/complimentrylogs/by-order/${orderId}`,
      {
        headers: {
          authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      }
    );
    return response.data; // response is array
  },

  getGrpItem: async ({
    page = 1,
    pageSize = 10,
    startDate = null,
    endDate = null,
  }) => {
    const response = await apiService.get("/complimentrylogs/grouped", {
      params: {
        page,
        pageSize,
        startDate,
        endDate,
      },
      headers: {
        authorization: "Bearer " + _BaseAPIService.retrieveToken(),
      },
    });

    return response.data;
  },

  detail: async (orderId) => {
    const response = await apiService.get(
      `/complimentrylogs/by-order/${orderId}`,
      {
        headers: {
          authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      }
    );
    return response.data;
  },
};

export default ComplimentryService;
